<template>
  <div>
    <div class="welcome-back">
      <div class="user-holder">
        <div v-if="payload.picture_url" class="wb-avatar">
          <!--<i class="fa fa-user-o" aria-hidden="true"></i>-->
          <img :src="payload.picture_url" alt="" />
        </div>
        <div class="welcome-avatar" />
        <h3 v-if="payload.first_name">{{ $t('welcome_back') }}</h3>
        <h3 v-if="payload.first_name">{{ payload.first_name }}</h3>

        <h3 v-if="!payload.first_name">{{ $t('welcome_back').replace(/,\s?$/, '') }}</h3>
      </div>

      <a
        :href="`/index.php?controller=social-login&action=${action}&wftkn=${wftkn}`"
        class="social-btn connect"
        :class="{ disabled: isProcessing }"
        @click.prevent="sendConnectRequest()"
      >
        {{ $t('connect_button') }}
      </a>
    </div>
  </div>
</template>

<script>
  import { logUserAction } from '../../utils/logging'
  export default {
    props: ['payload', 'api', 'action', 'wftkn', 'baseData'],

    data() {
      return {
        isProcessing: false,
      }
    },

    mounted() {
      this.animateSocial()
    },

    methods: {
      sendConnectRequest() {
        logUserAction({ type: 'user_action', label: 'User Clicked Welcome Back Connect Button' })
        if (this.isProcessing || this.api.includes('preview')) return

        this.isProcessing = true
        this.$eventHub.$emit('showGlobalLoader')

        try {
          const url = `${this.api}&action=${this.action}&wftkn=${this.wftkn}`
          window.location.href = url
        } catch (error) {
          this.isProcessing = false
          this.$eventHub.$emit('hideGlobalLoader')
        }
      },

      animateSocial() {
        setTimeout(() => {
          const btns = document.getElementsByClassName('social-btn')
          for (let i = 0; i < btns.length; i++) {
            setTimeout(() => {
              if (btns[i]) {
                btns[i].style.opacity = 1
                btns[i].style.marginLeft = '0'
              }
            }, 200 + i * 50)
          }
        }, 20)
      },
    },
  }
</script>

<style>
  .welcome-back .wifi-symbol .wifi-circle {
    border-color: #55acee;
  }
  .welcome-back .connecting-text {
    text-align: center;
  }
  .welcome-back {
    text-align: center;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .welcome-back .connect {
    opacity: 0;
    margin-left: -20px;
    /*margin: 0 auto;*/
  }
  .welcome-back .connect.disabled {
    opacity: 0.6;
    pointer-events: none;
    cursor: not-allowed;
  }
  .user-holder {
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    margin: 20px 0 20px 0;
  }
  .user-holder h3 {
    padding: 0;
    margin: 2px;
    letter-spacing: 0.05em;
    font-size: 20px;
  }
  .wb-avatar {
    height: 72px;
    width: 72px;
    background: #ccc;
    border-radius: 50%;
    margin: 20px 0 10px 0;

    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 32px;
    color: #fff;
    overflow: hidden;
    box-shadow: rgba(0, 0, 0, 0.19) 0px 0px 5px 0px;
    border: 4px solid #fff;
  }
  .wb-avatar img {
    width: 100%;
  }
</style>
